import { InView } from 'react-intersection-observer';
import style from '../knear.module.scss'
import AccordionItem from '../accordion/accordion';
import animations from '@styles/animations.module.scss'
import { AccordionItemInterface } from '../knear-state';

interface AccordionSectionProps {
    title: string;
    items: Array<AccordionItemInterface>;
}
const AccordionSection = ({ title, items }: AccordionSectionProps) => {
    return (
        <section className={`${style.section} ${style.section_light}`}>
            <div className={`${style.container}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry?.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${style.container__title} ${style.container__title_left} ${animations.scroll__animation}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={style.accordion}>
                    {
                        items.map((item: any, index: number) => {
                            return (
                                <AccordionItem key={index} id={item.id} title={item.title} text={item.text} />
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default AccordionSection;